import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, FormControlLabel, FormHelperText, Grid, Paper, Switch, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import errorFormat from '../../../../../utils/errorFormat';
import configSiteUrls from '../../../configs/configSiteUrls';

import { useAddAcessoInformacaoAnexosMutation } from '../acessoInformacaoAnexoApiSlice';
import { useAddAcessoInformacaoMutation } from '../acessoInformacaoApiSlice';
import { ISacessoInformacao, ISacessoInformacaoLoginResponse, AcessoInformacao, AcessoInformacaoDTO, AcessoInformacaoLoginResponse } from '../types/AcessoInformacao';
import { TxtSexo } from '../../../../../components/formControls/TxtSexo';

import { TxtDocumentoCPFCNPJ } from '../../../../../components/formControls/TxtDocumentoCPFCNPJ';
import { TxtTelefone } from '../../../../../components/formControls/TxtTelefone';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import GeralAnexosUpload from '../../licitacao/create/GeralAnexosUpload';
import convertImageToWeb from '../../../../../utils/convertImageToWeb';
import { TxtCategoriaAcessoInformacao } from '../../../../../components/formControls/TxtCategoriaAcessoInformacao';

export const AcessoInformacaoCreate = () => {
  const [acessoInformacao, SetAcessoInformacao] = useState<AcessoInformacao>(ISacessoInformacao);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [createAcessoInformacao, status] = useAddAcessoInformacaoMutation();

  const [createAnexos, statusCreateAnexos] = useAddAcessoInformacaoAnexosMutation();
  const [acessoInformacaoAnexoParaSalvar, setAcessoInformacaoAnexoParaSalvar] = useState<File[]>([]);
  const [acessoInformacaoLoginResponse, setAcessoInformacaoLoginResponse] = useState<AcessoInformacaoLoginResponse>(ISacessoInformacaoLoginResponse);
  const [showLoginInfo, setShowLoginInfo] = useState(false);

  const handleFileAnexoChange = async (files: File[]) => {
    const convertedFiles = await Promise.all(files.map(file => convertImageToWeb(file)));
    setAcessoInformacaoAnexoParaSalvar(prev => [...prev, ...convertedFiles]);
  };
  const handleOnDeleteParaSalvar = (index: number) => {
    setAcessoInformacaoAnexoParaSalvar(prev => prev.filter((_, i) => i !== index));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    if (name === 'exercicio') {
      // Só números
      const somenteNumeros = value.replace(/\D/g, '').slice(0, 4);

      SetAcessoInformacao(prev => ({
        ...prev,
        exercicio: somenteNumeros === '' ? null : Number(somenteNumeros)
      }));

      e.target.value = somenteNumeros;

      // Mantém o cursor no local correto
      setTimeout(() => {
        e.target.setSelectionRange(cursorPosition, cursorPosition);
      }, 0);

      return;
    }

    // Demais campos
    SetAcessoInformacao(prev => ({
      ...prev,
      [name]: value
    }));

    // Aguarde até que o DOM seja atualizado
    setTimeout(() => {
      const input = e.target;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  };

  const handleChangeSexo = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    SetAcessoInformacao(prev => ({
      ...prev,
      sexo: e.target.value
    }));
  };

  const handleChangeCategoria = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    SetAcessoInformacao(prev => ({
      ...prev,
      categoria: e.target.value
    }));
  };

  const handleChangeIdentificar = (e: React.ChangeEvent<HTMLInputElement>) => {
    const anonimo = e.target.checked;

    SetAcessoInformacao(prev => ({
      ...prev,
      anonimo,
      // Se for anônimo (unchecked = false), limpa documento e nome
      documento: anonimo ? prev.documento : '',
      nome: anonimo ? prev.nome : '',
      email: anonimo ? prev.email : '',
      telefone: anonimo ? prev.telefone : '',
      sexo: anonimo ? prev.sexo : ''
    }));
  };

  const handleExcluirTodosAnexos = () => {
    setAcessoInformacaoAnexoParaSalvar([]);
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!acessoInformacao.anonimo) {
      if (acessoInformacao.documento === null) {
        enqueueSnackbar('O campo Documento é obrigatório.', { variant: 'warning' });
        return;
      }

      if (!acessoInformacao.nome) {
        enqueueSnackbar('O Nome deve ser informado!', { variant: 'warning' });
        return;
      }

      if (!acessoInformacao.email) {
        enqueueSnackbar('O Email deve ser informado!', { variant: 'warning' });
        return;
      }
      if (!acessoInformacao.telefone) {
        enqueueSnackbar('O Telefone deve ser informado!', { variant: 'warning' });
        return;
      }
    }
    if (!acessoInformacao.categoria) {
      enqueueSnackbar('A Categoria deve ser informada!', { variant: 'warning' });
      return;
    }
    if (!acessoInformacao.observacao) {
      enqueueSnackbar('A Observação deve ser informada!', { variant: 'warning' });
      return;
    }

    const parms: AcessoInformacaoDTO = {
      id: acessoInformacao.id || '',
      idCategoria: acessoInformacao.categoria || '',
      nome: acessoInformacao.nome || '',
      documento: acessoInformacao.documento || '',
      email: acessoInformacao.email || '',
      sexo: acessoInformacao.sexo || '',
      telefone: acessoInformacao.telefone || '',
      formatoContato: acessoInformacao.formatoContato || '',
      observacao: acessoInformacao.observacao || '',
      anonimo: acessoInformacao.anonimo || false
    };

    setLoading(true);
    const result: any = await createAcessoInformacao(parms);
    const dataAcessoInformacao = result?.data;
    const idAcessoInformacao = dataAcessoInformacao?.id;

    if (idAcessoInformacao) {
      setAcessoInformacaoLoginResponse(dataAcessoInformacao); // armazena login e senha no estado
      setShowLoginInfo(true); // mostra a div de confirmação

      if (acessoInformacaoAnexoParaSalvar.length) {
        const formData = new FormData();
        acessoInformacaoAnexoParaSalvar.forEach(file => formData.append('imagens', file));
        formData.append('acessoInformacaoID', idAcessoInformacao);
        createAnexos(formData);
      }
      handleExcluirTodosAnexos();
      //navigate(configSiteUrls.SITE_ACESSO_INFORMACAO_T);
    }
    setLoading(false);
  }

  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      // navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          mt: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: { xs: '100%', sm: '90%', md: '90%', lg: '90%' },
            maxWidth: '1200px',
            p: 3
          }}
        >
          {showLoginInfo && acessoInformacaoLoginResponse?.login && acessoInformacaoLoginResponse?.senha ? (
            <>
              <Paper elevation={0} sx={{ mt: 4, p: 3, textAlign: 'center' }}>
                <Typography variant="h6" gutterBottom>
                  Sua solicitação foi enviada com sucesso! Guarde o login e a senha abaixo para consultar o andamento sempre que precisar:
                </Typography>
                <Typography variant="body1">
                  <strong>Login:</strong> {acessoInformacaoLoginResponse.login}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  <strong>Senha:</strong> {acessoInformacaoLoginResponse.senha}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setShowLoginInfo(false); // esconde a div se quiser permitir nova submissão
                    navigate(configSiteUrls.SITE_ACESSO_INFORMACAO_PUBLIC_MENU); // ou qualquer outra ação
                  }}
                >
                  Voltar
                </Button>
              </Paper>
            </>
          ) : (
            <>
              <Typography variant="h6" component="h1" sx={{ mb: 2 }}>
                Preencha o formulário para criar uma nova solicitação de Acesso Informação
              </Typography>

              <form onSubmit={handleSubmit} method="POST">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} lg={4}>
                    <TxtDocumentoCPFCNPJ
                      value={acessoInformacao.documento || ''}
                      onChange={val => SetAcessoInformacao(prev => ({ ...prev, documento: val }))}
                      disabled={acessoInformacao.anonimo}
                      required={!acessoInformacao.anonimo}
                    />
                  </Grid>

                  {/* Nome */}
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        disabled={acessoInformacao.anonimo}
                        required={!acessoInformacao.anonimo}
                        label="Nome"
                        name="nome"
                        onChange={handleChange}
                        size="small"
                        inputProps={{ maxLength: 50 }}
                        value={acessoInformacao.nome}
                      />
                      <FormHelperText>{acessoInformacao.nome?.length}/50 caracteres</FormHelperText>
                    </FormControl>
                  </Grid>

                  {/* Email */}
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        disabled={acessoInformacao.anonimo}
                        required={!acessoInformacao.anonimo}
                        label="E-mail"
                        name="email"
                        onChange={handleChange}
                        size="small"
                        inputProps={{ maxLength: 50 }}
                        value={acessoInformacao.email}
                      />
                      <FormHelperText>{acessoInformacao.email?.length}/50 caracteres</FormHelperText>
                    </FormControl>
                  </Grid>

                  {/* Sexo */}
                  <Grid item xs={12} sm={6}>
                    <TxtSexo
                      disabled={acessoInformacao.anonimo}
                      required={!acessoInformacao.anonimo}
                      value={acessoInformacao.sexo}
                      onChange={handleChangeSexo}
                      helperText={`${acessoInformacao.sexo?.length ?? 0}/50 caracteres`}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TxtTelefone
                      value={acessoInformacao.telefone || ''}
                      onChange={val => SetAcessoInformacao(prev => ({ ...prev, telefone: val }))}
                      disabled={acessoInformacao.anonimo}
                      required={!acessoInformacao.anonimo}
                    />
                  </Grid>

                  {/* Categoria */}
                  <Grid item xs={12}>
                    <TxtCategoriaAcessoInformacao
                      value={acessoInformacao.categoria}
                      onChange={handleChangeCategoria}
                      required
                      helperText={`${acessoInformacao.categoria?.length ?? 0}/50 caracteres`}
                    />
                  </Grid>

                  {/* Observação */}
                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        required
                        label="Observação"
                        name="observacao"
                        onChange={handleChange}
                        size="small"
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 1000 }}
                        value={acessoInformacao.observacao}
                      />
                      <FormHelperText>{acessoInformacao.observacao?.length}/1000 caracteres</FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <Box>
                      <Accordion defaultExpanded={false}>
                        <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                          <Typography color="secondary" variant="body1" gutterBottom>
                            Anexos
                          </Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                          <Paper>
                            <GeralAnexosUpload
                              arquivosSalvos={null}
                              arquivosParaSalvar={acessoInformacaoAnexoParaSalvar}
                              onFileChange={handleFileAnexoChange}
                              onDeleteParaSalvar={handleOnDeleteParaSalvar}
                              onDeleteAll={handleExcluirTodosAnexos}
                              tipo="ACESSO_INFORMACAO"
                            />
                          </Paper>
                        </AccordionDetails>
                      </Accordion>
                    </Box>
                  </Grid>

                  {/* Botões */}
                  <Grid item xs={12}>
                    <Box display="flex" gap={2}>
                      <Button type="submit" variant="contained" color="secondary">
                        Gravar
                      </Button>

                      <Button variant="contained" color="primary" onClick={() => navigate(configSiteUrls.SITE_ACESSO_INFORMACAO_PUBLIC_MENU)}>
                        Voltar
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </>
          )}
        </Paper>
      </Box>
    </>
  );
};
